export const LONGITUDE = 112.5
export const LATITUDE = 2.5
export const CENTER = [LONGITUDE, LATITUDE]
export const ZOOM = [4]
export const OUTBREAKS = ['measles', 'mumps', 'rubella', 'poliomyelitis', 'tetanus']



// WEBPACK FOOTER //
// ./src/config.js